import { useCallback, useEffect, useState } from 'react'
import { useScreenSize } from '@/themes/media-query'
import { Button } from 'devextreme-react/button'
import type { dump } from '@/model/qsadminapi/QsAdminApiModuleModel'
import classNames from 'classnames'
import { Item as ToolbarItem, Toolbar } from 'devextreme-react/toolbar'
import './DumpPanel.scss'
import DumpEditorForm from '@/routes/dumps/DumpEditor.form'
import { ScrollView } from 'devextreme-react/scroll-view'
import { useParams } from 'react-router-dom'

const DumpPanel = (props: {
  dump: dump | null
  visible: boolean
  onPinButtonClick: (value: boolean) => void
  onCloseButtonClcik: () => void
}) => {
  const { isLarge, isMedium } = useScreenSize()
  const { clientId } = useParams()

  const [isPinned, setIsPinned] = useState(JSON.parse(localStorage.getItem(`dump-panel`) ?? '{"pinned":false}').pinned)

  const onPinClick = useCallback(() => {
    const dump: dump | null = JSON.parse(localStorage.getItem(`dump-panel`) ?? '{"dump":null}').dump
    localStorage.setItem(`dump-panel`, JSON.stringify({ visible: true, dump: dump, pinned: !isPinned }))
    setIsPinned(!isPinned)
  }, [isPinned])

  const onCloseClick = () => {
    localStorage.setItem(`dump-panel`, JSON.stringify({ visible: false, dump: null, pinned: false }))
    setIsPinned(false)
    props.onCloseButtonClcik()
  }

  useEffect(() => {
    props.onPinButtonClick(isPinned)
  }, [isPinned, props])

  return (
    <>
      <div
        id="dump-panel"
        className={classNames({
          panelDump: true,
          openPanelDump: props.visible,
          pinPanelDump: isPinned && (isLarge || isMedium),
        })}
        style={{ marginRight: clientId ? '0px' : '20px' }}
      >
        <div className="data-wrapper">
          <Toolbar className="panel-toolbar">
            <ToolbarItem location="before">
              <span className="dump-name value">{`${props.dump?.ded_Dis}`}</span>
            </ToolbarItem>
            <ToolbarItem location="after" visible={isLarge || isMedium}>
              <Button icon={isPinned ? 'pin' : 'unpin'} stylingMode="text" onClick={onPinClick} />
            </ToolbarItem>
            <ToolbarItem location="after">
              <Button icon="close" stylingMode="text" onClick={onCloseClick} />
            </ToolbarItem>
          </Toolbar>
          <ScrollView className="panel-scroll">
            <DumpEditorForm dump={props.dump}></DumpEditorForm>
          </ScrollView>
        </div>
      </div>
    </>
  )
}

export default DumpPanel
